import type { ReactNode } from 'react'
import { useContext } from 'react'

import { createSharedContext } from '@twistopayments/design-system/utils'

import type { TagSize, TagVariant } from '../components/tag'

/**
 * Context
 */

type ContextValue = {
  size: TagSize
  variant: TagVariant
}

const Context = createSharedContext<ContextValue | undefined>('components/atoms/tag/utils/tag.context#0', undefined)

/**
 * Provider
 */

type Props = {
  children: ReactNode
  size: TagSize
  variant: TagVariant
}

export const TagContextProvider = ({ children, size, variant }: Props) => (
  <Context.Provider value={{ size, variant }}>{children}</Context.Provider>
)

/**
 * Hook
 */

export const useTagContext = () => {
  const context = useContext(Context)

  if (context === undefined) {
    throw new Error('useTagContext must be used within a TagContextProvider')
  }

  return context
}
